module.exports = "<p>\n  shared-component works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/shared-component/shared-component.component.html
// module id = ./src/app/component/pricing-booking/shared-component/shared-component.component.html
// module chunks = main